<template>
  <div>
    <form @submit.prevent="submitQuery">
      <b-form-group class="p-2 ">
        <b-form-group
          class="nested-form-group"
          label="Select The Exam Category You want to Check Stocking Details for :"
          label-for="category"
        >
          <b-form-select
            v-model="query.category"
            :options="categoryarr"
            @change="categoryChanged"
          >
            <b-form-select-option value="null"
              >--Select category--</b-form-select-option
            >
          </b-form-select>
        </b-form-group>

        <b-form-group
          class="nested-form-group"
          label="Select Institution You want to check stocking details for"
          label-for="institution"
        >
          <b-form-select
            v-model="query.institution"
            :options="institutionsarray"
          >
            <b-form-select-option value="null"
              >--Select Institution--</b-form-select-option
            >
          </b-form-select>
        </b-form-group>

        <b-form-group
          class="nested-form-group"
          label="Check Details by"
          label-for="checkby"
        >
          <b-form-select v-model="query.checkby" :options="checkbyarr">
            <b-form-select-option :value="structure">{{
              structure == 'Section' ? 'Course' : structure
            }}</b-form-select-option>
            <b-form-select-option value="null"
              >--Check by--</b-form-select-option
            >
          </b-form-select>
        </b-form-group>

        <div class="text-center">
          <b-overlay
            :show="proceeding"
            rounded
            opacity="0.6"
            spinner-small
            spinner-variant="primary"
          >
            <b-button
              :disabled="!substate"
              type="submit"
              class="w-50 p-2 btntxt"
              @click="submitQuery()"
              variant="warning"
            >
              Proceed
            </b-button>
          </b-overlay>

          <b-button
            v-if="proceeding"
            class="w-50 p-2 mt-3 btntxt"
            variant="dark"
            @click="proceeding = false"
          >
            Cancel
          </b-button>
        </div>
      </b-form-group>
    </form>

    <!-- {{ stockingdata }} -->
    <div class="p-3" v-if="dataretrieved">
      <h2 class="text-center">{{ generalstockingdata[0].name }}</h2>
      <h4 class="text-center" v-if="generalstockingdata.length > 0">
        This Table has {{ generalstockingdata[0].data.length }} rows
      </h4>
      <tabler
        v-if="generalstockingdata.length > 0"
        class="esq m-1 p-2"
        :datas="usedatas"
        :fields="generalstockingdata[0].fields"
      ></tabler>
    </div>

    <paginater
      v-if="dataretrieved"
      :intervalnum="intervalnum"
      :pages="pages"
      :endnum="endnum"
      :endss="endss"
      :datalength="endss"
      @paginator="newPage"
      @changeInterval="effectInterval"
    ></paginater>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Tabler from "@/components/admin/Tabler";
import Paginater from "@/components/Paginater";
//import '@/assets/mathjax/es5/tex-chtml-full.js';

export default {
  components: {
    Tabler,
    Paginater
  },
  data() {
    return {
      proceeding: false,
      query: this.getquery(),
      categoryarr: [],
      institutionsarray: [],
      structure: "",
      org: "",

      checkbyarr: [
        {
          text: "Stocker",
          value: "stocker"
        },
        {
          text: "Today's Stock",
          value: "today"
        },
        {
          text: "List all Questions",
          value: "listall"
        }
      ],
      startnum: 0,
      limitnum: this.endss,
      intervalnum: 10,
      endnum: 10,
      btnrange: this.endss,
      pages: 1,
      stockingdata: [
        {
          data: []
        }
      ],
      dataretrieved: false
    };
  },
  created() {
    this.org = this.details.clearance_organization;

    if (this.generalstockingdata.length > 0) {
      this.dataretrieved = true;
      this.stockingdata = this.generalstockingdata;
    }
  },
  mounted() {
    // let inst = this.allinsti.filter((x) => x.available == "Yes").map((x) => x.name);
    // this.institutionsarr = inst;

    let typesarr = this.Categories.map(x => x.name);
    this.categoryarr = typesarr;
  },
  beforeRouteLeave(to, from, next) {
    //this.clearstat()
    next();
  },
  methods: {
    ...mapActions("admin", ["queryGeneralStocking", "clearstat"]),
    categoryChanged() {
      this.query.institution = null; // If the type is changed, reset the select Object. set the institution property to null
      this.subjectsarray = []; // Empty the subjects property Array
      this.institutionsarray = []; // Empties the Institutions Array

      let inst = this.allinsti
        .filter(x => x.category == this.query.category)
        .map(x => x.name);
      this.institutionsarray = inst;

      // this.query.organization = this.org
      let tabi = this.Categories.filter(
        x => x.organization_name == this.org && x.name == this.query.category
      ).map(x => x.structure);
      this.structure = tabi[0];

      let sameName = this.Categories.filter(
        x => x.organization_name == this.org && x.name == this.query.category
      ).map(x => x.sameName);
      this.sameName = sameName[0];

      if (this.sameName == "Yes") {
        this.query.institution = this.query.category;
        let unparsedSubjects = this.allinsti
          .filter(
            x =>
              x.name == this.query.category &&
              x.category == this.query.category &&
              x.organization_name == this.org
          )
          .map(x => x.subjects_offered);
        this.subjectsarray = JSON.parse(unparsedSubjects);
      }
    },
    institutionChanged() {
      // this.upgrade.institution =
      this.subjectsarray = []; // Anytime user changes Institution, empty the levelsarray
      // this.upgrade.institution_shortname = this.allinsti.find(x => x.name == this.upgrade.institution).short_name
      // If the selected category to be taken is undergraduate
      this.levelsarray = []; // Anytime user changes Institution, empty the levelsarray
      // this.upgrade.institution_shortname = this.allinsti.find(x => x.name == this.upgrade.institution).short_name
      // If the selected category to be taken is undergraduate
      if (this.structure == "Section") {
        // Get the levels config Object for this particular institution under the undergraduate category
        // The Levels Configuration Object contains all the Configuration for each level and courses available under the selected institution
        let unparsedLevelConfig = this.allinsti
          .filter(
            x =>
              x.category == this.upgrade.category &&
              x.name == this.upgrade.institution
          )
          .map(x => x.levels_config);
        let parsedLevelConfig = JSON.parse(unparsedLevelConfig); // Parse the levels config from string

        // Get the name of each level available in the levels config. It should return "['100', '200']" depending on the levels available in the Configurations Object
        this.levelsarray = parsedLevelConfig.map(x => x.name);
      }
      // Get the Subjects available for this Institution from the Institutions Object and map them to 'unparsedSubjects'
      let unparsedSubjects = this.allinsti
        .filter(
          x =>
            x.name == this.upgrade.institution &&
            x.category == this.upgrade.category &&
            x.organization_name == this.org
        )
        .map(x => x.subjects_offered);
      this.subjectsarray = JSON.parse(unparsedSubjects); // parse the Array and set the value of the data property 'subjectsarray' to it

      // console.log(this.subjectsarray)
      // console.log(this.levelsarray)
    },
    levelChanged() {
      this.coursesarray = [];
      // Get the levels config Object for this particular institution under the undergraduate category
      // The Levels Configuration Object contains all the Configuration for each level and courses available under the selected institution
      let unparsedLevelConfig = this.allinsti
        .filter(
          x =>
            x.category == this.upgrade.category &&
            x.name == this.upgrade.institution
        )
        .map(x => x.levels_config);
      let parsedLevelConfig = JSON.parse(unparsedLevelConfig); // Parse the levels config from string

      // Get the Chosen Level exact config Array.
      // To see output. Console.log(config) in development mode
      let config = parsedLevelConfig
        .filter(x => x.name == this.upgrade.planlevel)
        .map(x => x.config);
      // Now get the Courses from the courses Object of the Chosen level exact config Object
      let courses = config[0]
        .filter(x => x.name == "courses")
        .map(x => x.values);

      // Inject this Array into the general courses Array for Selection
      this.coursesarray = courses[0];
    },
    getquery() {
      return {
        category: null,
        institution: null,
        checkby: null,
        structure: "",
        organization: ""
      };
    },

    async submitQuery() {
      this.proceeding = true;
      this.query.organization = this.details.clearance_organization;
      this.query.structure = this.structure

      return await this.queryGeneralStocking(this.query)
        .then(() => {
        //   console.log(response);
          this.proceeding = false;
          this.dataretrieved = true;
          this.stockingdata = this.generalstockingdata;
        })
        .catch(error => {
          console.log(error.response);
          // alert(error.response.statusText)
          this.proceeding = false;
        });
    },

    stopproceed() {
      this.proceeding = false;
    },
    newPage(page) {
      // alert(page)
      this.pages = page;
      let newend = this.intervalnum * page;

      if (newend < this.endss) {
        this.endnum = newend;
        this.startnum = newend - this.intervalnum;
      } else {
        this.endnum = this.endss;
        this.startnum = newend - this.intervalnum;
      }
    },
    effectInterval(newinterval) {
      this.intervalnum = newinterval;
      this.pages = 1;
      this.newPage(this.pages);
    }
  },
  computed: {
    ...mapState({
      allinsti: state => state.admin.listinstitutions,
      Categories: state => state.admin.Categories,
      generalstockingdata: state => state.admin.generalstockingdata,
      details: state => state.loginmaster.details
    }),
    substate() {
      if (
        this.query.category == null ||
        this.query.institution == null ||
        this.query.checkby == null ||
        this.proceeding
      ) {
        return false;
      } else {
        return true;
      }
    },
    usedatas() {
      return this.stockingdata[0].data.slice(this.startnum, this.endnum);
    },
    endss() {
      let end = this.stockingdata[0].data.length;
      return end;
    },
    ranger() {
      let ranger = Math.ceil(
        this.stockingdata[0].data.length / this.intervalnum
      );
      return ranger;
    }
  }
};
</script>

<style scoped>
.btntxt {
  font-size: 1.3rem;
}
</style>
